/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const MergeMode = {
    Merge: 'Merge',
    MergeLeftJoin: 'MergeLeftJoin',
    Append: 'Append'
} as const;
export type MergeMode = typeof MergeMode[keyof typeof MergeMode];


export function instanceOfMergeMode(value: any): boolean {
    for (const key in MergeMode) {
        if (Object.prototype.hasOwnProperty.call(MergeMode, key)) {
            if (MergeMode[key as keyof typeof MergeMode] === value) {
                return true;
            }
        }
    }
    return false;
}

export function MergeModeFromJSON(json: any): MergeMode {
    return MergeModeFromJSONTyped(json, false);
}

export function MergeModeFromJSONTyped(json: any, ignoreDiscriminator: boolean): MergeMode {
    return json as MergeMode;
}

export function MergeModeToJSON(value?: MergeMode | null): any {
    return value as any;
}

export function MergeModeToJSONTyped(value: any, ignoreDiscriminator: boolean): MergeMode {
    return value as MergeMode;
}

